import { Box } from 'juhuui';
import React, { useEffect, useState } from 'react';
import shallow from 'zustand/shallow';

import { useScrollTo } from '../hooks/useScrollTo';
import { Grid, Link, TextSm } from '../styles';
import { useStore } from '../zustand';
import LinkBarItem from './linkBarItem';

function LinkBar({ items, refs, services = false }) {
  const [active, setActive] = useState(0);

  const [inView] = useStore(
    (state) => (services ? [state.servicesInView] : [state.praxisInView]),
    shallow
  );

  useEffect(() => {
    const item0 = inView[0];
    const item1 = inView[1];
    const item2 = inView[2];
    const item3 = inView[3];

    if (!services && item0) {
      setActive(0);
    }
    if (!services && item1) {
      setActive(1);
    }

    // for navigation services page
    if (services && item0 && !item1) {
      setActive(0);
    }
    if (services && item1 && !item2) {
      setActive(1);
    }
    if (item2) {
      setActive(2);
    }
    if (item3) {
      setActive(3);
    }
  }, [inView]);

  const scrollTo = useScrollTo();

  const changeActive = (index) => {
    setActive(index);
    scrollTo(refs[index]);
  };

  return (
    <Box
      css={{
        bg: 'tom.bgBright',
        pos: 'sticky',
        top: '-1px',
        mt: '4',
        w: 'full',
        zIndex: '1',
      }}
    >
      <Grid
        css={{
          margin: 'auto',
          maxW: 'var(--max-width)',
        }}
        fw={{ columns: 12 }}
      >
        <TextSm
          as="nav"
          css={{
            bg: 'tom.bgBright',
            color: 'tom.textHighlight',
            column: ['1/span 12', undefined, '1/span 12'],
            d: 'flex',
            pt: ['4', undefined, '3'],
            px: 'var(--px)',
            fontSize: ['xs', undefined, 'xs'],
          }}
          // ml={['0', undefined, '-50vw']}
          // pl={['0', undefined, '50vw']}
          // pr={['0', undefined, '1rem']}
        >
          {items.map((item, index, { length }) => (
            <LinkBarItem
              key={index}
              active={index === active}
              after={index > active}
              first={index === 0}
              firstActive={active === 0}
              index={index}
              item={item}
              last={index === length - 1}
              setActive={changeActive}
            />
          ))}
        </TextSm>
      </Grid>
    </Box>
  );
}

export default LinkBar;
